import React, { useState, useEffect } from 'react';
import * as PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { DialogDecorated, DialogBody, DialogFooter, DialogTitle } from 'components/redux-dialog';
import { ButtonContainer } from 'components/button/button-container';
import { Button } from 'components/button';
import { GENERATE_THUMBNAIL_DIALOG } from 'pages/my-videos.page/edit.page/fragments/thumbnail/index';
import { generateThumbnailRequestAction } from 'common/actions';
import { websiteSelector } from 'common/selectors';
import { reduxNotificationAction } from 'components/redux-notification/actions';
import { REDUX_NOTIFICATION_TYPES } from 'components/redux-notification';
import { dialogSelector } from 'components/redux-dialog/selectors';
import { hideDialogAction } from 'components/redux-dialog/actions';
import { VideoPlayerWrapper } from 'components/video-player/video-player-wrapper';

export const GenerateThumbnailDialog = ({ video }) => {
  const website = useSelector(websiteSelector);
  const { playerConfiguration } = website;
  const dialog = useSelector(dialogSelector)(GENERATE_THUMBNAIL_DIALOG);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [timestamp, setTimestamp] = useState(0);

  const hideDialog = () => dispatch(hideDialogAction(GENERATE_THUMBNAIL_DIALOG));
  const generateThumbnail = (seconds) => {
    if (seconds === 0) {
      dispatch(reduxNotificationAction('Please select thumbnail first.', true, 5, REDUX_NOTIFICATION_TYPES.ERROR));
      return;
    }

    dispatch(generateThumbnailRequestAction(video.id, Math.round(seconds * 1000)));
  };

  useEffect(() => {
    let interval;

    if (dialog.show) {
      setTimestamp(0);

      interval = setInterval(() => {
        const videoPlayerHtmlElem = document.querySelector(`.ct-generate-thumbnail-dialog video`);

        if (videoPlayerHtmlElem) {
          videoPlayerHtmlElem.addEventListener('pause', () => setTimestamp(videoPlayerHtmlElem.currentTime));

          clearInterval(interval);
        }
      }, 500);
    }

    return () => {
      clearInterval(interval);
    };
  }, [dialog.show]);

  return (
    <DialogDecorated className="ct-generate-thumbnail-dialog" dialogName={GENERATE_THUMBNAIL_DIALOG}>
      <DialogTitle>
        <h1>{t('create_new_thumbnail')}</h1>
      </DialogTitle>
      <DialogBody>
        <p>{t('thumbnail_dialog_description')}</p>
        <VideoPlayerWrapper playerConfiguration={playerConfiguration} video={video} />
      </DialogBody>
      <DialogFooter>
        <ButtonContainer style={{ justifyContent: 'space-between' }}>
          <Button onClick={() => hideDialog()} secondary={true}>
            {t('cancel')}
          </Button>
          <Button onClick={() => generateThumbnail(timestamp)}>{t('create')}</Button>
        </ButtonContainer>
      </DialogFooter>
    </DialogDecorated>
  );
};

GenerateThumbnailDialog.propTypes = {
  video: PropTypes.object.isRequired,
};
